import React, { Component } from 'react';
/** PERSONAL */
import Footer from '../exercise/Footer';
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        };
    }

    componentDidMount() {
        this.MQLoad();
    }

    componentDidUpdate() {
        this.MQLoad();
    }

    createHtml = str => ({ __html: str ? str : `&nbsp;` });

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            // 然而, 我们这里并不是可编辑的
            MQ.StaticMath(item);
        });
    };

     toggleAnswer = (val, e) => {
        this.setState({visible: val});
    };

    render() {
        const { visible } = this.state;
        const { num } = this.props;
        let originData = this.props.data;
        let data = reverseParseTextView(originData);
        return (
            <div className="box-exercise" ref={(el) => { this.viewer = el }}>
                <div className="exercise-content">
                    <div className="exercise-num"><p className="math_text">{`${num + 1}.`}</p></div>
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)} />
                    {
                        visible && <div className='exercise-options exercise-options-delivery' style={{ color: '#00b1ff' }}>
                            {
                                data.answer.map((item, i) =>
                                    <p className='math_text answer' style={{ marginTop: 0 }} key={i} dangerouslySetInnerHTML={this.createHtml(item)}></p>
                                )
                            }
                        </div>
                    }
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/deliverySecond/viewForView.js